// Hospitality H1 (Sep 2026) — the read-only "Delivering to" block shown
// to a hotel-referred guest in place of the delivery-address form. There
// is intentionally no edit control: the destination is set on the server
// from the hotel's stored location and cannot be changed by the guest.
import React from "react";
import { Lock } from "lucide-react";
import { formatDestinationLines } from "../../lib/hostReferral";

export default function HostDestinationCard({ context, compact = false, testId = "host-destination-card" }) {
  if (!context) return null;
  const lines = formatDestinationLines(context);
  const hostName = context.host_display_name || context.destination?.name || "your hotel";
  return (
    <div className="rounded-xl border border-emerald-300 bg-emerald-50 p-3 text-stone-900" data-testid={testId}>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-emerald-800">Delivering to</div>
      <div className="mt-1 font-semibold" data-testid={`${testId}-name`}>{context.destination?.name || hostName}</div>
      {!compact && lines.map((l) => (
        <div key={l} className="text-sm text-stone-700">{l}</div>
      ))}
      <div className="mt-1 text-sm font-medium text-stone-800">{context.receiving_point || "Front Desk"}</div>
      <div className="mt-2 flex items-start gap-1.5 text-xs text-emerald-900" data-testid={`${testId}-locked`}>
        <Lock className="h-3.5 w-3.5 mt-0.5 shrink-0" aria-hidden="true" />
        <span>Delivery location provided by {hostName}. It can&apos;t be changed for this order.</span>
      </div>
    </div>
  );
}
